(function() {
'use strict';

angular
    .module('TR')
    .directive('boardTypeFilters', function(broker,
                hotelSearch) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'partials/home/directivetemplate?type=BoardTypeFilters',
        scope: {
            hotel: '=',
            buttonClass: '='
        },

        link(scope) {
            const cancel = scope.$watch('hotel.Rooms', h => {
                if (!h || _.isEmpty(h)) {
                    return;
                }

                cancel();

                scope.showMenu = false;

                if (scope.hotel == null || scope.hotel.Rooms == null) {
                    return;
                }

                scope.$watchCollection('filter.BoardTypes', function(v, o) {
                    if (v == null || v === o) {
                        return;
                    }
                    broker.publish('boardTypeFilterUpdated', v);
                });

                const boardTypes = {};

                scope.hotel.Rooms.forEach(function(r) {
                    r.Availability.forEach(function(a) {
                        if (!boardTypes[a.BoardType] || boardTypes[a.BoardType].Text.length > a.BoardDescription.length) {
                            boardTypes[a.BoardType] = {
                                Text: a.BoardDescription,
                                Value: a.BoardType,
                                Count: 0
                            };
                        }

                        boardTypes[a.BoardType].Count += 1;
                    });

                    scope.showMenu = Object.keys(boardTypes).length > 1;

                    // convert object to array for the dropdown multi select control
                    scope.boardTypeOptions = [];
                    _.forEach(boardTypes, function(b) {
                        scope.boardTypeOptions.push(b);
                    });
                });

                let filterBoardTypes = angular.copy(hotelSearch.getFilter().BoardTypes);
                filterBoardTypes = _.filter(filterBoardTypes, fbt =>
                    _.some(scope.boardTypeOptions, option => option.Value === fbt)
                );
                scope.filter = {
                    BoardTypes: filterBoardTypes
                };
            });
        }
    };
});
})();
